class Drawer {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    let scrollTop = 0;

    $("." + this.el).on('click', function() {
      $('html').toggleClass('is-drawer');
      if (body.classList.contains('no_scroll')) {
        body.style.top = '';
        body.classList.remove('no_scroll');
        window.scrollTo(0, scrollTop);
      } else {
        scrollTop = window.scrollY;
        body.style.top = (scrollTop * -1) + 'px';
        body.classList.add('no_scroll');
      }
    })
  }
}